import styled from '@emotion/styled';
import React from 'react';
import { ThemeProps } from '@theme/base';
import { SkeletonElement, SkeletonSize, SkeletonVariant } from '@components/common/skeleton-loading';
import { mq } from '@styles/breakpoints';

/* ***************** *
 *       Types       *
 * ***************** */

export interface RoomTypeGroupSkeletonProps {
  numOfComponents?: number;
}

/* ***************** *
 *       Styles      *
 * ***************** */
const Container: any = styled.div(({ theme }: ThemeProps) => ({
  display: 'flex',
  flexDirection: 'column',
  border: `2px solid ${theme.custom.colors.group10.light}`,
  padding: theme.custom.spacing.large,
  marginBottom: theme.custom.spacing.large,

  ['&:last-of-type']: {
    marginBottom: 0
  },

  [mq.small]: {
    flexDirection: 'row'
  }
}));

const Column: any = styled.div(({ theme }: ThemeProps) => ({
  width: '100%',

  ['&:first-of-type']: {
    borderBottom: `1px solid ${theme.custom.colors.group10.base}`,
    paddingBottom: theme.custom.spacing.xSmall
  },

  [mq.small]: {
    ['&:first-of-type']: {
      borderBottom: 'none',
      paddingBottom: 0,
      width: '45%'
    },
    ['&:last-of-type']: {
      width: '55%'
    }
  }
}));

const Row: any = styled.div(({ theme }: ThemeProps) => ({
  display: 'flex',
  justifyContent: 'space-between',
  padding: `${theme.custom.spacing.xSmall}px 0`,
  borderBottom: `1px solid ${theme.custom.colors.group10.light}`,

  ['&:last-of-type']: {
    borderBotton: 'none'
  }
}));

const SkeletonImage: any = styled(SkeletonElement)({
  display: 'none',
  maxWidth: 266,

  [mq.small]: {
    display: 'block'
  }
});

/* ************************** *
 *    RoomTypeGroupSkeleton   *
 * ************************** */

export const RoomTypeGroupSkeleton = ({ numOfComponents = 3 }: RoomTypeGroupSkeletonProps) => {
  const renderRoomTypeSkeleton = (index: number) => (
    <Container key={`RoomTypeGroupSkeletonContainer-${index}`}>
      <Column>
        <SkeletonElement variant={SkeletonVariant.HEADING} size={SkeletonSize.SMALL} />
        <SkeletonImage variant={SkeletonVariant.RECTANGLE} width={'90%'} height={140} />
      </Column>
      <Column>
        {[...Array(5)].map((_, index) => (
          <Row key={`RoomTypeGroupSkeleton-${index}`}>
            <SkeletonElement width={'40%'} />
            <SkeletonElement width={'40%'} />
          </Row>
        ))}
      </Column>
    </Container>
  );

  return <>{[...Array(numOfComponents)].map((_, index: number) => renderRoomTypeSkeleton(index))}</>;
};
